import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { inr } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { toast } from "sonner";

export function ProductCard({ product, index = 0 }) {
  const { has, toggle } = useWishlist();
  const active = has(product.id);
  const discount = product.mrp > product.price ? Math.round(((product.mrp - product.price) / product.mrp) * 100) : 0;

  const onWish = async (e) => {
    e.preventDefault();
    const res = await toggle(product.id);
    if (res.needAuth) toast.error("Please sign in to save favourites");
    else toast.success(active ? "Removed from wishlist" : "Added to wishlist");
  };

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative overflow-hidden bg-[#F3EECB] aspect-[3/4]">
        <img
          src={product.images?.[0]}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {product.new_arrival && (
          <span className="absolute top-3 left-3 uplabel bg-[#FBF7DE] px-2.5 py-1">New</span>
        )}
        {discount > 0 && (
          <span className="absolute top-3 right-12 uplabel bg-[var(--bronze)] text-[#FBF7DE] px-2.5 py-1">{discount}% Off</span>
        )}
        <button
          onClick={onWish}
          data-testid={`wishlist-toggle-${product.id}`}
          className="absolute top-3 right-3 w-8 h-8 grid place-items-center bg-[#FBF7DE]/90 backdrop-blur-sm rounded-full transition-colors hover:bg-[#FBF7DE]"
          aria-label="Toggle wishlist"
        >
          <Heart className={`w-4 h-4 transition-colors ${active ? "fill-[var(--maroon)] text-[var(--maroon)]" : "text-[var(--bronze)]"}`} />
        </button>
      </div>
      <div className="pt-4 space-y-1">
        <div className="uplabel text-[0.62rem]">{product.audience} · {product.category.replace("-", " ")}</div>
        <h3 className="font-serif text-xl text-[var(--bronze)] leading-tight transition-colors group-hover:text-[var(--olive)]">{product.name}</h3>
        <div className="flex items-center gap-2">
          <span className="text-[var(--bronze)] font-medium">{inr(product.price)}</span>
          {discount > 0 && <span className="text-sm text-[var(--olive)]/70 line-through">{inr(product.mrp)}</span>}
        </div>
      </div>
    </Link>
  );
}
